import { RELITIX_FIELD_TOOLTIPS } from "~/constants/tooltips/RelitixAdvancedSearchTooltips";

export const KIND = {
  currency: "currency",
  date: "date",
  datetime: "datetime",
  distance: "distance",
  listingEffectivenessGrade: "listingEffectivenessGrade",
  listingEffectivenessImpact: "listingEffectivenessImpact",
  number: "number",
  percent: "percent",
  rookieRating: "rookieRating",
  switchRisk: "switchRisk",
  teamLeader: "teamLeader",
  text: "text",
};

export const SECTION_DEFS = [
  {
    key: "location",
    title: "Location Details",
    fields: [
      {
        key: "closest_office_name",
        label: "Our Closest Office",
        tooltip: RELITIX_FIELD_TOOLTIPS.closestOffice,
        kind: KIND.text,
      },
      {
        key: "closest_office_address",
        label: "Our Closest Office Address",
        tooltip: RELITIX_FIELD_TOOLTIPS.closestOfficeAddress,
        kind: KIND.text,
      },
      {
        key: "dist_to_closest_office",
        label: "Dist. to Our Closest Office",
        tooltip: RELITIX_FIELD_TOOLTIPS.distanceToClosestOffice,
        kind: KIND.distance,
      },
      {
        key: "dist_to_office",
        label: "Dist. to Current Office",
        tooltip: RELITIX_FIELD_TOOLTIPS.distanceToCurrentOffice,
        kind: KIND.distance,
      },
      {
        key: "production_zip_code",
        label: "Center of Production Zip",
        tooltip: RELITIX_FIELD_TOOLTIPS.centerOfProductionZip,
        kind: KIND.text,
      },
      {
        key: "team_leader",
        label: "Team Leader",
        tooltip: RELITIX_FIELD_TOOLTIPS.teamLeader,
        kind: KIND.teamLeader,
      },
    ],
  },
  {
    key: "milestones",
    title: "Milestones",
    fields: [
      {
        key: "first_trans_date_current_office",
        label: "First Transaction at Current Office",
        tooltip: RELITIX_FIELD_TOOLTIPS.firstTransactionCurrentOffice,
        kind: KIND.date,
      },
      {
        key: "first_trans_date",
        label: "First Transaction in MLS",
        tooltip: RELITIX_FIELD_TOOLTIPS.firstTransactionMls,
        kind: KIND.date,
      },
    ],
  },
  {
    key: "performance",
    title: "Performance Metrics",
    fields: [
      {
        key: "rookie_potential_rating",
        label: "Rookie Rating",
        tooltip: RELITIX_FIELD_TOOLTIPS.rookieRating,
        kind: KIND.rookieRating,
      },
      {
        key: "switch_color",
        label: "Current Switch Risk",
        tooltip: RELITIX_FIELD_TOOLTIPS.currentSwitchRisk,
        kind: KIND.switchRisk,
      },
      {
        key: "list_eff_grade",
        label: "Listing Effectiveness Grade",
        tooltip: RELITIX_FIELD_TOOLTIPS.listingEffectivenessGrade,
        kind: KIND.listingEffectivenessGrade,
      },
      {
        key: "list_eff_impact",
        label: "Listing Effectiveness Impact",
        tooltip: RELITIX_FIELD_TOOLTIPS.listingEffectivenessImpact,
        kind: KIND.listingEffectivenessImpact,
      },
      {
        key: "five_yr_closed_pct",
        label: "5 Year Batting Avg",
        tooltip: RELITIX_FIELD_TOOLTIPS.fiveYearBattingAverage,
        kind: KIND.percent,
      },
      {
        key: "five_yr_tot_listings",
        label: "5 Year Listing Count",
        tooltip: RELITIX_FIELD_TOOLTIPS.fiveYearListingCount,
        kind: KIND.number,
      },
    ],
  },
  {
    key: "freshness",
    title: "Data Freshness",
    fields: [
      {
        key: "update_date",
        label: "Last Updated",
        tooltip: RELITIX_FIELD_TOOLTIPS.lastUpdated,
        kind: KIND.datetime,
      },
    ],
  },
];
